"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintWrapper = void 0;
const solana_contrib_1 = require("@saberhq/solana-contrib");
const token_utils_1 = require("@saberhq/token-utils");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const pda_1 = require("./pda");
class MintWrapper {
    constructor(sdk) {
        this.sdk = sdk;
        this.program = sdk.programs.MintWrapper;
    }
    get provider() {
        return this.sdk.provider;
    }
    newWrapper({ hardcap, tokenMint, baseKP = web3_js_1.Keypair.generate(), tokenProgram = spl_token_1.TOKEN_PROGRAM_ID, admin = this.program.provider.wallet.publicKey, payer = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const [mintWrapper, nonce] = yield (0, pda_1.findMintWrapperAddress)(baseKP.publicKey, this.program.programId);
            return {
                mintWrapper,
                tx: new solana_contrib_1.TransactionEnvelope(this.provider, [
                    this.program.instruction.newWrapper(nonce, hardcap, {
                        accounts: {
                            base: baseKP.publicKey,
                            mintWrapper,
                            admin,
                            tokenMint,
                            tokenProgram,
                            payer,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        },
                    }),
                ], [baseKP]),
            };
        });
    }
    newWrapperAndMint(_a) {
        var { mintKP = web3_js_1.Keypair.generate(), decimals = 6 } = _a, newWrapperArgs = __rest(_a, ["mintKP", "decimals"]);
        return __awaiter(this, void 0, void 0, function* () {
            const provider = this.provider;
            const { mintWrapper, tx: initMintProxyTX } = yield this.newWrapper(Object.assign(Object.assign({}, newWrapperArgs), { tokenMint: mintKP.publicKey }));
            const initMintTX = yield (0, token_utils_1.createInitMintInstructions)({
                provider,
                mintAuthority: mintWrapper,
                freezeAuthority: mintWrapper,
                mintKP,
                decimals,
            });
            return {
                mintWrapper,
                mint: mintKP.publicKey,
                tx: initMintTX.combine(initMintProxyTX),
            };
        });
    }
    /**
     * Fetches info on a minter.
     * @param minter
     * @returns
     */
    fetchMinter(wrapper, authority) {
        return __awaiter(this, void 0, void 0, function* () {
            const [minterAddress] = yield (0, pda_1.findMinterAddress)(wrapper, authority, this.program.programId);
            const accountInfo = yield this.program.provider.connection.getAccountInfo(minterAddress);
            if (!accountInfo) {
                return null;
            }
            return this.program.coder.accounts.decode("Minter", accountInfo.data);
        });
    }
    newMinter(wrapper, authority, allowance) {
        return __awaiter(this, void 0, void 0, function* () {
            const [minter, bump] = yield (0, pda_1.findMinterAddress)(wrapper, authority, this.program.programId);
            return this.sdk.newTx([
                this.program.instruction.newMinter(bump, {
                    accounts: {
                        auth: {
                            mintWrapper: wrapper,
                            admin: this.program.provider.wallet.publicKey,
                        },
                        minterAuthority: authority,
                        minter,
                        payer: this.program.provider.wallet.publicKey,
                        systemProgram: web3_js_1.SystemProgram.programId,
                    },
                }),
                this.program.instruction.minterUpdate(allowance, {
                    accounts: {
                        auth: {
                            mintWrapper: wrapper,
                            admin: this.program.provider.wallet.publicKey,
                        },
                        minter,
                    },
                }),
            ]);
        });
    }
    /**
     * Updates a minter's allowance.
     * @param minter
     * @param allowance
     * @returns
     */
    minterUpdate(wrapper, authority, allowance) {
        return __awaiter(this, void 0, void 0, function* () {
            const [minter] = yield (0, pda_1.findMinterAddress)(wrapper, authority, this.program.programId);
            return this.sdk.newTx([
                this.program.instruction.minterUpdate(allowance, {
                    accounts: {
                        auth: {
                            mintWrapper: wrapper,
                            admin: this.program.provider.wallet.publicKey,
                        },
                        minter,
                    },
                }),
            ]);
        });
    }
    transferAdmin(wrapper, nextAdmin) {
        return this.sdk.newTx([
            this.program.instruction.transferAdmin({
                accounts: {
                    mintWrapper: wrapper,
                    admin: this.program.provider.wallet.publicKey,
                    nextAdmin,
                },
            }),
        ]);
    }
    acceptAdmin(wrapper) {
        return this.sdk.newTx([
            this.program.instruction.acceptAdmin({
                accounts: {
                    mintWrapper: wrapper,
                    pendingAdmin: this.program.provider.wallet.publicKey,
                },
            }),
        ]);
    }
}
exports.MintWrapper = MintWrapper;
//# sourceMappingURL=mintWrapper.js.map